import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./core/auth/login/login.routes').then((m) => m.LOGIN_ROUTES),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
      },
      {
        path: 'tenders',
        loadChildren: () =>
          import('./features/tenders/tenders.routes').then((m) => m.TENDERS_ROUTES),
      },
      {
        path: 'ai-drafting',
        loadChildren: () =>
          import('./features/ai-drafting/ai-drafting.routes').then((m) => m.AI_DRAFTING_ROUTES),
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./features/templates/templates.routes').then((m) => m.TEMPLATES_ROUTES),
      },
      {
        path: 'manage-sections',
        loadChildren: () =>
          import('./features/manage-sections/manage-sections.routes').then(
            (m) => m.MANAGE_SECTIONS_ROUTES,
          ),
      },
      
        {
          path: 'template-builder',
          loadChildren: () =>
          import('./features/template-builder/template-builder.routes').then((m) => m.TEMPLATES_BUILDER_ROUTES),
        },
      
      {
        path: 'eligibility',
        loadChildren: () =>
          import('./features/eligibility/eligibility.routes').then((m) => m.ELIGIBILITY_ROUTES),
      },
      {
        path: 'compliance',
        loadChildren: () =>
          import('./features/compliance/compliance.routes').then((m) => m.COMPLIANCE_ROUTES),
      },
      {
        path: 'evaluation',
        loadChildren: () =>
          import('./features/evaluation/evaluation.routes').then((m) => m.EVALUATION_ROUTES),
      },
      {
        path: 'technical-evaluation',
        loadComponent: () =>
          import('./features/evaluation/technical-evaluation/technical-evaluation.component').then(
            (m) => m.TechnicalEvaluationComponent,
          ),
      },
      {
        path: 'financial-evaluation',
        loadComponent: () =>
          import('./features/evaluation/financial-evaluation/financial-evaluation.component').then(
            (m) => m.FinancialEvaluationComponent,
          ),
      },
      {
        path: 'financial-evaluation/:tenderId',
        loadComponent: () =>
          import('./features/evaluation/financial-evaluation/financial-evaluation.component').then(
            (m) => m.FinancialEvaluationComponent,
          ),
      },
      {
        path: 'submitted-bids',
        loadChildren: () =>
          import('./features/submitted-bids/submitted-bids.routes').then(
            (m) => m.SUBMITTED_BIDS_ROUTES,
          ),
      },
      {
        path: 'clarifications',
        loadChildren: () =>
          import('./features/clarifications/clarifications.routes').then(
            (m) => m.CLARIFICATIONS_ROUTES,
          ),
      },
      {
        path: 'pre-bid-queries',
        loadChildren: () =>
          import('./features/pre-bid-queries/pre-bid-queries.routes').then(
            (m) => m.PRE_BID_QUERIES_ROUTES,
          ),
      },
      {
        path: 'pre-qualification-evaluation',
        loadChildren: () =>
          import('./features/pre-qualification-evaluation/pre-qualification-evaluation.routes').then(
            (m) => m.PRE_QUALIFICATION_EVALUATION_ROUTES,
          ),
      },
      {
        path: 'emd-evaluation',
        loadChildren: () =>
          import('./features/emd-evaluation/emd-evaluation.routes').then(
            (m) => m.EMD_EVALUATION_ROUTES,
          ),
      },
      {
        path: 'workflow',
        loadChildren: () =>
          import('./features/workflow/workflow.routes').then((m) => m.WORKFLOW_ROUTES),
      },
      {
        path: 'workflow-config',
        loadChildren: () =>
          import('./features/workflow-config/workflow-config.routes').then(
            (m) => m.WORKFLOW_CONFIG_ROUTES,
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/reports/reports.routes').then((m) => m.REPORTS_ROUTES),
      },
      {
        path: 'documents',
        loadChildren: () =>
          import('./features/documents/documents.routes').then((m) => m.DOCUMENTS_ROUTES),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
